import _              from 'lodash'
import React          from 'react'
import { withRouter } from 'react-router'
import { Alert      } from 'react-bootstrap'

import { isValidEmail, currentLocation } from 'alto-utils/lib/utils'
import { Panel, HorizontalForm         } from 'alto-react-components/lib/components'
import { withAuthMessage               } from 'alto-react-base-auth/lib/utils'

import { BadRequestError               } from 'lib/errors'
import { withAuthContext               } from './context'

class InitPasswordReset extends React.Component
  constructor: (props) ->
    super(props)

    @state = { email: '', error: null }

  render: ->
    <Panel className="auth-panel" id="init-password-reset-panel" header="Reset hesla" bsStyle="info">
      {@alert()}
      {@form()}
    </Panel>

  alert: ->
    <Alert id="init-password-reset-alert" bsStyle="danger">{@state.error}</Alert> if @state.error

  form: ->
    value   = @state.email
    isValid = isValidEmail(value)

    if value.length
      help = if isValid then '' else 'Není validní formát emailu'
    else
      help = 'Nesmí být prázdné'

    <HorizontalForm>
      <HorizontalForm.Control id='email' type='email' label='Email' placeholder='Zadejte email'
       value={value} valid={isValid} help={help}
       onChange={(value) => @setState(email: value)}
       onKeyPress={(e) => @submit() if e.key == 'Enter'} />

      <HorizontalForm.Button id='init-password-reset-submit' caption='Potvrdit' bsStyle="primary"
                             onClick={@submit} disabled={not isValid} />
    </HorizontalForm>

  submit: =>
    @context.auth.initPasswordReset(@state.email)
      .then (response) =>
        @props.history.push(withAuthMessage('/', 'password_reset_initiated', 'warning'))

        null # otherwise runaway promise
      .catch BadRequestError, (error) =>
        @setState(error: 'Uživatel se zadanou emailovou adresou nebyl nalezen.')

class ConfirmPasswordReset extends React.Component
  constructor: (props) ->
    super(props)

    @state =
      password: ''
      passwordConfirmation: ''
      errors: {}

  render: ->
    <Panel className="auth-panel" id="confirm-password-reset-panel" header="Reset hesla" bsStyle="info">
      {@alert()}
      {@form()}
    </Panel>

  alert: ->
    errors = _.compact(_.at(@state.errors, 'detail', 'token'))

    if errors.length
      <Alert bsStyle="danger">{errors.join(' ')}</Alert>

  form: ->
    passwordErrors = @errorsFor('password')

    <HorizontalForm>
      <HorizontalForm.Control id='password' type="password" label='Heslo'
       valid={!passwordErrors?} help={passwordErrors}
       placeholder='Zadejte heslo'
       value={@state.password}
       onChange={(value) => @setState(password: value)}
       onKeyPress={(e)   => @submit() if e.key == 'Enter'} />

      <HorizontalForm.Control id='password-confirmation' type="password" label='Ověření hesla'
       valid={!@state.passwordConfirmation.length? or @isPasswordConfirmed()}
       help={'Neshoduje se' unless @isPasswordConfirmed()}
       placeholder='Zadejte heslo ještě jednou'
       value={@state.passwordConfirmation}
       onChange={(value) => @setState(passwordConfirmation: value)}
       onKeyPress={(e)   => @submit() if e.key == 'Enter'} />

      <HorizontalForm.Button id='confirm-password-reset-submit' caption='Potvrdit' bsStyle="primary"
                             onClick={@submit} disabled={!@isValid()} />
    </HorizontalForm>

  submit: =>
    { user_id, token } = currentLocation().query

    @context.auth.confirmPasswordReset(user_id, token, @state.password)
      .then (response) =>
        @props.history.push(withAuthMessage('/', 'password_reset_successful', 'success'))

        null # otherwise runaway promise
      .catch (error) =>
        @setState(errors: error.data or {})

  isValid: ->
    @state.password.length and @isPasswordConfirmed()

  isPasswordConfirmed: ->
    @state.password == @state.passwordConfirmation

  errorsFor: (fieldName) ->
    @state.errors[fieldName]?.join(' ')

export InitPasswordReset    = withRouter(withAuthContext(InitPasswordReset))
export ConfirmPasswordReset = withRouter(withAuthContext(ConfirmPasswordReset))
